import type { FC } from 'react';
import Project from '@/pages/Project';
import ProjectLegacy from '@/pages/ProjectLegacy';
import { FF_PROJECTS_V2, useFeatureFlag } from '@/hooks/useFeatureFlag';

const ProjectDetailRoute: FC = () => {
    const { enabled: isProjectsV2Enabled, isResolved } =
        useFeatureFlag(FF_PROJECTS_V2);

    if (!isResolved) {
        return;
    }

    return isProjectsV2Enabled ? <Project /> : <ProjectLegacy />;
};

export default ProjectDetailRoute;
